import React from 'react';
import "../template-file-css/document-file-template.css";


export const GHP_MedicationInformedConsentForm = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='GHP_MedicationInformedConsentForm' className='file-pdf-document'>
            <div className='file-template'>


                <h4>Medication </h4>

                <b>Patient was instructed as follows regarding their medication: </b>

                <table>
                    <tr>
                        <td className="w-750">
                            <span className="eleHeader w-750;">Continued Medications / Dosage listed:</span>
                        </td>
                    </tr>


                    <tr>
                        <td className="w-375">
                            <input type="text" name="txt1" id="txt1" className=" add-only" placeholder="1" />
                        </td>
                        <td className="w-375">
                            <input type="text" name="txt2" id="txt2" className=" add-only" placeholder="2" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-375">
                            <input type="text" name="txt3" id="txt3" className=" add-only" placeholder="3" />
                        </td>
                        <td className="w-375">
                            <input type="text" name="txt4" id="txt4" className=" add-only" placeholder="4" />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className="w-750">
                            <span className="eleHeader w-750;">New Medications / Dosage listed:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className="w-375">
                            <input type="text" name="txt11" id="txt11" className=" add-only" placeholder="1" />
                        </td>
                        <td className="w-375">
                            <input type="text" name="txt12" id="txt12" className=" add-only" placeholder="2" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-375">
                            <input type="text" name="txt13" id="txt13" className=" add-only" placeholder="3" />
                        </td>
                        <td className="w-375">
                            <input type="text" name="txt14" id="txt14" className=" add-only" placeholder="4" />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className="w-750">
                            <span className="eleHeader w-750;">Discontinued Medications / Dosage listed:</span>
                        </td>
                    </tr>

                    <tr>
                        <td className="w-375">
                            <input type="text" name="txt21" id="txt21" className=" add-only" placeholder="1" />
                        </td>
                        <td className="w-375">
                            <input type="text" name="txt22" id="txt22" className=" add-only" placeholder="2" />
                        </td>
                    </tr>
                </table>
                <strong>Written Consent: </strong>

                <p>
                    I understand the medication(s) listed above are necessary and potentially helpful for my mental illness.  Off-label medication use (not FDA approved) and black box warnings have been clearly explained to me by the prescribing physician or her/her designee.  I consent to my individualized medication plan/administration and was counseled on the side effects/risk/benefits of prescribed medications and was counseled extensively and warned about discontinuing medication without consulting with the doctor.  I am also aware that the medication dose may be adjusted over time with the psychiatrist. Individual was encouraged to select a date for a follow-up appointment to re-evaluate medications (see date above). I was advised that in an event of any unusual changes in their health, mood, etc. that I should consult the prescribing physician with any questions or concerns.  I was informed on how to obtain the prescribing physician's name and contact information from the prescription bottles.  I was also made aware of my right to revoke consent for medication at any time unless the use of medications is court ordered.
                </p>

                <input type="checkbox" name="cbTelehealth" id="cbTelehealth_1" className="add-only" value="Telehealth" />
                <strong> Due to COVID 19 and the use of telehealth, a verbal consent was obtained.</strong>

            </div>
        </form>
    )
}